import { StorageService } from "../storage.service";
import { PlanStyle } from "./style";



export const Plan = () => {
    const plan = StorageService.getUsers()?.plan || 'free'
    return <PlanStyle $variant={plan}>{plan}</PlanStyle>;
};
